import type { FaireProductEntity } from "../../entity_types/product";

export const p_606ri0voou: FaireProductEntity = {
  token: "p_606ri0voou",
  type: "product",
  name: "Fallon Embroidered Sleeve Poncho - Sage",
  brandToken: "b_41hrqq6ws3",
  brandName: "Three Bird Nest",
  imageUrl:
    "https://cdn.faire.com/fastly/42a6db52acb355f80ae1da10c7134f5c2c31ffae073d3f88d5585cc91b1a877a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7d07eea0700701058348ccc5b821a2f23c79e793628f610ac75bf6bf96f0af70.jpeg",
    "https://cdn.faire.com/fastly/171f459e0bb909355baf248b26bb3c7ced0849fbf216497605b6080860f4728f.jpeg",
    "https://cdn.faire.com/fastly/423b84d8ee471c22cb107c79d4dc9cb0bcacde05cc861d38c6f5c66eab39faf0.jpeg",
  ],
  priceDollars: 29.1,
  description:
    'Light and breezy this boxy-cut pullover has three-quarter sleeves with generous volume to gracefully drape at the sides like a boho-chic kimono. Fallon has artistic embroidery in colored threads and geo textures to flatter at the arms, with a straight hem that is easy to tuck in front and back and a wide boatneck that can go off the shoulder. \n\n*Due to lighting and differences in monitors, actual colors may vary slightly from what appears online.\n\nDimensions:  26"x 49"\n80% Polyester, 20% Cotton\nHand wash cold, Lay flat to dry\nImport',
  tags: [],
  msrpDollars: 58.2,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:39.289Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
